import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CorporateAccountService, GeneralService, IUser } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { noPastDateValidator, endDateAfterStartDateValidator } from '../../pages/assisted-booking/validator';

@Component({
  selector: 'app-extra-service-visa',
  templateUrl: './extra-service-visa.component.html',
  styleUrls: ['./extra-service-visa.component.scss']
})
export class ExtraServiceVisaComponent implements OnInit {
    private toastState = {
  startPast: false,
  endPast: false,
  endBeforeStart: false
};
  otherFacilitiesData = {
    form: { label: 'Nationality of Travellers', placeholder: 'Nationality of travelers' },
    caption: 'Please enter the nationality of the traveler '
  }
  user: IUser | undefined
  nationality: [{name: '', label: '', checked: false}]
 
  locationName: any;
  booking: any;
form=  new FormGroup({
      destination_country: new FormControl('', [Validators.required]),
      purpose_of_travel: new FormControl('', [Validators.required]),
      // length_of_stay: new FormControl('', [Validators.required]),
            startDate: new FormControl('', [Validators.required, noPastDateValidator()]),
      endDate: new FormControl('', [Validators.required, noPastDateValidator()]),
      max_budget: new FormControl('', [Validators.required]),
      currency: new FormControl('GBP', [Validators.required]),
      additional_requests: new FormControl('',),
      nationality_of_travelers:new FormControl([]),
    },
           {
              validators: endDateAfterStartDateValidator('startDate', 'endDate')
      });
    
  loading: boolean = false
  endDate: any;
    minDate: any;
currencies = [
    {
        "name": "USD",
        "code": "USD"
    },
    {
        "name": "GBP",
        "code": "GBP"
    },
    {
        "name": "EUR",
        "code": "EUR"
    },
    {
        "name": "NGN",
        "code": "NGN"
    },
    {
        "name": "EGP",
        "code": "EGP"
    }
]
  constructor(
    public bsModalRef: BsModalRef,
    private options: ModalOptions,
    private service: CorporateAccountService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private gs: GeneralService,


  ) { }

  ngOnInit(): void {
    this.user = this.options.initialState?.user as IUser
    this.booking = this.options.initialState?.booking
    const ctrlStart = this.form.get('startDate');
    const ctrlEnd = this.form.get('endDate');

    ctrlStart?.valueChanges.subscribe(() => {
      if (ctrlStart.hasError('pastDate')) {
        if (!this.toastState.startPast) {
          this.toastr.error(
            'No past date allowed. Please enter the current date or a future date.'
          );
          this.toastState.startPast = true;
          this.form.get('startDate')?.setValue('');
        }
      } else {
        this.toastState.startPast = false;
      }
    });
      ctrlEnd?.valueChanges.subscribe(() => {
    if (ctrlEnd.hasError('pastDate')) {
      if (!this.toastState.endPast) {
        this.toastr.error(
          'No past date allowed. Please enter today or a future date for End Date.'
        );
        this.toastState.endPast = true;
        this.form.get('endDate')?.setValue('');
      }
    } else {
      this.toastState.endPast = false;
    }
      });
     this.form.valueChanges.subscribe(() => {
    if (this.form.hasError('endBeforeStart')) {
      if (!this.toastState.endBeforeStart) {
        this.toastr.error(
          'End date cannot be earlier than the start date.'
        );
        this.toastState.endBeforeStart = true;
        this.form.get('startDate')?.setValue('');
        this.form.get('endDate')?.setValue('');
      }
    } else {
      this.toastState.endBeforeStart = false;
    }
  });
            const today = new Date();
    this.minDate = today.toISOString().split('T')[0];

  }

  getRemovedRule(event: string) {
    this.nationality.some((element: {name: string, checked: boolean}) => {
      if (element.name.includes(event)) {
        element.checked = false
      }
    })
  }

  locationChangeF({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    console.log(s)
    this.form.controls.destination_country.setValue(s);

  }

   getDate(event: any) {
    this.endDate = event.value;
  }


  submit() {
    this.loading = true
    const {destination_country, nationality_of_travelers, additional_requests, purpose_of_travel, max_budget,
      currency, startDate, endDate} = this.form.value;

    const payload = {
      destination_country,
      additional_requests,
      purpose_of_travel,
            startDate: startDate,
      endDate: endDate,
            max_budget,
      currency,

      nationality_of_travelers,
      employee: this.user?.id || this.user?._id,
      business: this.user?.business?.id || this.user?.business?._id,
      booking: this.booking || ''
    }

    if (this.booking !== null) {
      this.service.createExtraServiceVisa(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
          this.toastr.error(this.gs.getErrMsg(err));
          this.loading = false

          // this.bsModalRef.hide()
      })
    } else {
      delete payload.booking

      this.service.createExtraServiceVisa(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
          this.toastr.error(this.gs.getErrMsg(err));
          this.loading = false

          // this.bsModalRef.hide()
      })
    }
    // console.log(payload)
  }



}
